import { createSlice } from "@reduxjs/toolkit";
import Cookies from "js-cookie";

export const authSlice = createSlice({
  name: "auth",
  initialState: {
    accessToken: Cookies.get("access_token") || null,
    refreshToken: Cookies.get("refresh_token") || null,
    activityAccessToken: null,
    accessRoutes: JSON.parse(localStorage.getItem("routes") || "[]"),
    sessionExpired: false,
    permissions: null,
    accessDenied: false,
  },
  reducers: {
    setAccessToken: (state, action) => {
      state.accessToken = action.payload;
      Cookies.set("access_token", action.payload);
    },
    setActivityAccessToken: (state, action) => {
      state.activityAccessToken = action.payload;
    },
    setRefreshToken: (state, action) => {
      state.refreshToken = action.payload;
      Cookies.set("refresh_token", action.payload);
    },
    setAccessRoutes: (state, action) => {
      state.accessRoutes = action.payload;
      localStorage.setItem("routes", JSON.stringify(action.payload));
    },
    
    showSessionExpiredModal: (state) => {
      state.sessionExpired = true;
    },
    hideSessionExpiredModal: (state) => {
      state.sessionExpired = false;
      state.accessToken = null;
      state.refreshToken= null
      Cookies.remove("access_token");
      Cookies.remove("refresh_token");
    },
    setPermissions : (state, action)=> {
      state.permissions = action.payload
    },
    showAccessDeniedModal: (state) => {
      state.accessDenied = true;
    },
    hideAccessDeniedModal: (state) => {
      state.accessDenied = false;
    },
  },
});

export const {
  setAccessToken,
  setActivityAccessToken,
  setRefreshToken,
  setAccessRoutes,
  showSessionExpiredModal,
  hideSessionExpiredModal,
  setPermissions,
  showAccessDeniedModal,
  hideAccessDeniedModal,
} = authSlice.actions;

export default authSlice.reducer;
